import UIFetchService from '../Service/UIFetchService';

import React, { useEffect, useState } from 'react';
import { Row, Col, Button, Tree, Modal, List, Input, Select, Tabs, Divider } from 'antd';
import { DownOutlined, CloseCircleOutlined, UserOutlined } from '@ant-design/icons';
import { isEmpty, isNotEmpty } from '../Service/Utils';

// title
// getUsers()
// setUsers(viewers, editors)
class PermissionModal extends React.Component {
    constructor() {
        super();
        this.state = {
            viewers: [],
            editors: [],
            action: 'VIEW'
        };
    }

    render() {
        const stateUsers = this.state.action === 'VIEW' ? this.state.viewers : this.state.editors;
        const users = this.state.action === 'VIEW' ? this.viewers : this.editors;
        return <Modal
            {...this.props}
            maskClosable={false}
            width={600}
            onOk={async () => await this.commit()}
        >
            <Row>
                <Col flex="50%" style={{ padding: '12px 0 12px 0' }}>
                    <Input.Search
                        size="small"
                        value={this.state.searchKey}
                        onChange={async ({ target: { value } }) => {
                            this.setState({ searchKey: value });
                            const url = `/api/v1/perm/teams${isEmpty(value) ? '' : '?searchKey=' + value}`;
                            const teams = await UIFetchService.get(url);

                            if (isNotEmpty(teams)) {
                                //this.users = {};
                                //this.flattenUsers(teams);
                            }
                            this.setState({ teams });
                        }}
                    />
                </Col>
                <Col style={{ padding: '12px 0 12px 0', margin: '0 0 0 10px' }}>
                    <Select
                        value={this.state.action}
                        onChange={action => this.setState({ action })}
                        size="small"
                    >
                        <Select.Option key='VIEW' value='VIEW'>使用权限</Select.Option>
                        <Select.Option key="EDIT" value="EDIT">编辑权限</Select.Option>
                    </Select>
                </Col>
            </Row>
            <Row>
                <Col flex="55%" style={{ padding: '12px 0 12px 0' }}>
                    {isNotEmpty(this.state.teams) && <Tree
                        style={{
                            width: 'auto',
                            overflowX: 'auto',
                            height: 500,
                            overflowY: 'auto',
                            wordBreak: 'keep-all',
                            whiteSpace: 'nowrap',
                            //border: '1px solid #f0f0f0',

                        }}
                        showIcon
                        switcherIcon={<DownOutlined />}
                        defaultExpandedKeys={['staff/*', 'intern/*']}
                        autoExpandParent={true}
                        checkable
                        onCheck={users => {
                            if (this.state.action === 'VIEW') {
                                this.setState({ viewers: users.map(id => id.toString()) });
                            } else {
                                this.setState({ editors: users.map(id => id.toString()) });
                            }
                        }}
                        checkedKeys={stateUsers}
                        treeData={this.state.teams}
                    />}
                </Col>
                <Col flex="45%">
                    <List
                        size="small"
                        header={`已选中${stateUsers.filter(id => id.match('^\\d+$')).length}人`}
                        style={{
                            width: 'auto',
                            overflowX: 'auto',
                            height: 500,
                            overflowY: 'auto',
                            wordBreak: 'keep-all',
                            whiteSpace: 'nowrap',
                            //border: '1px solid #f0f0f0',

                        }}
                    >
                        {stateUsers
                            .map(id => [id, users[id.toString()]])
                            .filter(bundle => bundle[1] !== undefined)
                            .map(([id, name], index) => <List.Item
                                key={index}
                            >
                                <Row style={{ width: '100%' }}>
                                    <Col flex="120px">
                                        <UserOutlined />
                                        <span style={{ fontSize: 12, margin: '0 10px 0 10px' }}>{name}</span>
                                    </Col>
                                    <Col><Button
                                        icon={<CloseCircleOutlined />}
                                        danger
                                        type="link"
                                        size="small"
                                        onClick={() => {
                                            if (this.state.action === 'VIEW') {
                                                this.setState({
                                                    viewers: stateUsers.filter((_, i) => i !== index)
                                                });
                                            } else {
                                                this.setState({
                                                    editors: stateUsers.filter((_, i) => i !== index)
                                                });
                                            }
                                        }}
                                    /></Col></Row>
                            </List.Item>)
                        }
                    </List>
                </Col>
            </Row>
        </Modal>;
    }

    async componentDidMount() {
        const teams = await UIFetchService.get(`/api/v1/perm/teams`);
        // const viewers = await UIFetchService.get(`/api/v1/querying_guide/templates/${this.props.tmplId}/perm_staffs?action=VIEW`);
        // const editors = await UIFetchService.get(`/api/v1/querying_guide/templates/${this.props.tmplId}/perm_staffs?action=EDIT`);
        const { viewers, editors } = await this.props.getUsers();
        //auth.appendLog('天机-模版编辑列表');
        this.viewers = {};
        this.editors = {}
        this.flattenUsers(teams);
        this.setState({ teams, viewers, editors });
    }

    flattenUsers(roots) {
        for (let root of roots) {
            if (isEmpty(root.children)) {
                this.viewers[root.key] = root.title;
                this.editors[root.key] = root.title;
            } else {
                this.flattenUsers(root.children);
            }
        }
    }

    async commit() {
        const viewers = this.state.viewers.filter(key => key.match('^\\d+$')).map(id => Number.parseInt(id));
        const editors = this.state.editors.filter(key => key.match('^\\d+$')).map(id => Number.parseInt(id));
        await this.props.setUsers(viewers, editors);
        this.props.onCancel();
    }
}

class ExtendPermissionModal extends React.Component {
    constructor() {
        super();
        this.state = {
            level: "TABLE_LEVEL",
            viewers: [],
            editors: [],
            selectedTeams: [],
            action: 'VIEW'
        };
    }

    render() {
        const stateUsers = this.state.action === 'VIEW' ? this.state.viewers : this.state.editors;
        const users = this.state.action === 'VIEW' ? this.viewers : this.editors;
        return <Modal
            {...this.props}
            maskClosable={false}
            width={600}
            onOk={async () => await this.commit()}
        >
            {this.props.lineLevel
                ? <Tabs
                    activeKey={this.state.level}
                    onChange={level => this.setState({ level })}
                >
                    <Tabs.TabPane
                        tab="表级"
                        tabKey='TABLE_LEVEL'
                        key="TABLE_LEVEL"
                    >
                        {this.renderTableLevel(stateUsers, users)}
                    </Tabs.TabPane>
                    <Tabs.TabPane
                        tab="行级"
                        tabKey='LINE_LEVEL'
                        key='LINE_LEVEL'
                    >
                        <PermissionLineLevelView
                            teams={this.state.selectedTeams}
                            onChange={selectedTeams => this.setState({ selectedTeams })}
                        />
                    </Tabs.TabPane>
                </Tabs>
                : this.renderTableLevel(stateUsers, users)}
        </Modal>;
    }

    renderTableLevel(stateUsers, users) {
        return <>
            <Row>
                <Col flex="50%" style={{ padding: '12px 0 12px 0' }}>
                    <Input.Search
                        size="small"
                        value={this.state.searchKey}
                        onChange={async ({ target: { value } }) => {
                            this.setState({ searchKey: value });
                            const url = `/api/v1/perm/teams${isEmpty(value) ? '' : '?searchKey=' + value}`;
                            const teams = await UIFetchService.get(url);

                            if (isNotEmpty(teams)) {
                                //this.users = {};
                                //this.flattenUsers(teams);
                            }
                            this.setState({ teams });
                        }}
                    />
                </Col>
                <Col style={{ padding: '12px 0 12px 0', margin: '0 0 0 10px' }}>
                    <Select
                        value={this.state.action}
                        onChange={action => this.setState({ action })}
                        size="small"
                    >
                        <Select.Option key='VIEW' value='VIEW'>使用权限</Select.Option>
                        <Select.Option key="EDIT" value="EDIT">编辑权限</Select.Option>
                    </Select>
                </Col>
            </Row>
            <Row>
                <Col flex="55%" style={{ padding: '12px 0 12px 0' }}>
                    {isNotEmpty(this.state.teams) && <Tree
                        style={{
                            width: 'auto',
                            overflowX: 'auto',
                            height: 500,
                            overflowY: 'auto',
                            wordBreak: 'keep-all',
                            whiteSpace: 'nowrap',
                            //border: '1px solid #f0f0f0',

                        }}
                        showIcon
                        switcherIcon={<DownOutlined />}
                        defaultExpandedKeys={['staff/*', 'intern/*']}
                        autoExpandParent={true}
                        checkable
                        onCheck={(users, {checked, node}) => {
                            if (this.state.action === 'VIEW') {
                                const viewers = [...this.state.viewers];
                                this.processAllLeafKeys(node, viewers, checked);
                                this.setState({ viewers });
                            } else {
                                const editors = [...this.state.editors];
                                this.processAllLeafKeys(node, editors, checked);
                                this.setState({ editors });
                            }
                        }}
                        checkedKeys={stateUsers}
                        treeData={this.state.teams}
                    />}
                </Col>
                <Col flex="45%">
                    <List
                        size="small"
                        header={`已选中${stateUsers.filter(id => id.match('^\\d+$')).length}人`}
                        style={{
                            width: 'auto',
                            overflowX: 'auto',
                            height: 500,
                            overflowY: 'auto',
                            wordBreak: 'keep-all',
                            whiteSpace: 'nowrap',
                            //border: '1px solid #f0f0f0',

                        }}
                    >
                        {stateUsers
                            .map(id => [id, users[id.toString()]])
                            .filter(bundle => bundle[1] !== undefined)
                            .map(([id, name], index) => <List.Item
                                key={index}
                            >
                                <Row style={{ width: '100%' }}>
                                    <Col flex="120px">
                                        <UserOutlined />
                                        <span style={{ fontSize: 12, margin: '0 10px 0 10px' }}>{name}</span>
                                    </Col>
                                    <Col><Button
                                        icon={<CloseCircleOutlined />}
                                        danger
                                        type="link"
                                        size="small"
                                        onClick={() => {
                                            if (this.state.action === 'VIEW') {
                                                this.setState({
                                                    viewers: stateUsers.filter((_, i) => i !== index)
                                                });
                                            } else {
                                                this.setState({
                                                    editors: stateUsers.filter((_, i) => i !== index)
                                                });
                                            }
                                        }}
                                    /></Col></Row>
                            </List.Item>)
                        }
                    </List>
                </Col>
            </Row>
        </>;
    }

    async componentDidMount() {
        const teams = await UIFetchService.get(`/api/v1/perm/teams`);
        const { viewers, editors } = await this.props.getUsers();
        const selectedTeams = await this.props.getTeams();
        this.viewers = {};
        this.editors = {}
        this.flattenUsers(teams);
        this.setState({ teams, viewers, editors, selectedTeams });
    }

    processAllLeafKeys(root, keys, checked) {
        if (root.leaf) {
            if (checked) {
                keys.push(root.key);
            } else {
                keys.splice(keys.indexOf(root.key), 1);
            }
            return;
        }
        if (isEmpty(root.children)) {
            return;
        }
        for (const child of root.children) {
            this.processAllLeafKeys(child, keys, checked);
        }
    }

    flattenUsers(roots) {
        for (let root of roots) {
            if (isEmpty(root.children)) {
                this.viewers[root.key] = root.title;
                this.editors[root.key] = root.title;
            } else {
                this.flattenUsers(root.children);
            }
        }
    }

    async commit() {
        const viewers = this.state.viewers.filter(key => key.match('^\\d+$')).map(id => Number.parseInt(id));
        const editors = this.state.editors.filter(key => key.match('^\\d+$')).map(id => Number.parseInt(id));
        await this.props.setUsers(viewers, editors);
        console.log(this.state.selectedTeams);
        const teams = this.state.selectedTeams.filter(key => key.startsWith('t:')).map(key => Number.parseInt(key.substring(2)));
        await this.props.setTeams(teams);
        this.props.onCancel();
    }
}

function PermissionLineLevelView(props) {
    const [teams, setTeams] = useState([]);
    const [teamsMembers, setTeamsMembers] = useState({});
    //const [selectedTeams, setSelectedTeams] = useState([]);
    const [searchKey, setSearchKey] = useState('');

    console.log(props);

    function processTeams(teamsMembers, teams, root) {
        //console.log(teamsMembers, teams, root);

        if (root.leaf) {
            for (const container of teams) {
                container.users.push(root);
            }
            root.checkable = false;
            // if (root.value.leader) {
            //     root.title = <span><UserOutlined />{root.title}<sup style={{ fontSize: 12, color: '#f5222d' }}>{'<leader>'}</sup></span>;
            // } else {
            //     root.title = <span><UserOutlined />{root.title}</span>;
            // }
        } else {
            if (root.key.startsWith("t:")) {
                const teamId = Number.parseInt(root.value)
                let container;
                if (!Number.isNaN(teamId)) {
                    container = teamsMembers[teamId];
                    if (container == undefined) {
                        container = { node: root, users: [] };
                        teamsMembers[teamId] = container;
                    }
                    for (const node of root.children) {
                        processTeams(teamsMembers, [...teams, container], node)
                    }
                }
            } else {
                for (const node of root.children) {
                    processTeams(teamsMembers, teams, node)
                }
            }
        }
    }

    async function fetchTeams(key) {
        const url = `/api/v1/perm/merged_teams${isEmpty(key) ? '' : '?searchKey=' + key}`;
        const original = await UIFetchService.get(url);
        const members = {};
        for (const node of original) {
            processTeams(members, [], node);
        }
        setTeamsMembers(members);
        console.log(members);
        setTeams(original);
    }

    useEffect(async () => {
        await fetchTeams(searchKey);
    }, []);

    return <>
        <Row>
            <Col flex="50%" style={{ padding: '12px 0 12px 0' }}>
                <Input.Search
                    size="small"
                    value={searchKey}
                    onChange={async ({ target: { value } }) => {
                        setSearchKey(value);
                        fetchTeams(value);
                    }}
                />
            </Col>
        </Row>
        <Row>
            <Col flex="300px" style={{ padding: '12px 0 12px 0' }}>
                {isNotEmpty(teams) && <Tree
                    style={{
                        width: 'auto',
                        overflowX: 'auto',
                        height: 500,
                        width: 300,
                        overflowY: 'auto',
                        overflowX: 'auto',
                        wordBreak: 'keep-all',
                        whiteSpace: 'nowrap',
                        //border: '1px solid #f0f0f0',

                    }}
                    showIcon
                    switcherIcon={<DownOutlined />}
                    defaultExpandedKeys={['staff/*', 'intern/*']}
                    autoExpandParent={true}
                    checkable
                    onCheck={keys => props.onChange(keys.filter(key => key.startsWith('t:')))}
                    checkedKeys={props.teams}
                    treeData={teams}
                />}
            </Col>
            <Col flex="245px" style={{
                overflowX: 'auto',
                overflowY: 'auto',
                width: 250,
                height: 512,
                margin: '0 0 0 3px'
            }}>
                {props.teams.filter(key => key.startsWith('t:'))
                    .map(key => Number.parseInt(key.substring(2)))
                    .map(id => teamsMembers[id])
                    .filter(team => team !== undefined)
                    .map(team => <>
                        <Row key={team.node.key}>
                            <Col>
                                <span style={{ fontSize: 12, color: 'gray' }}>{team.node.title}</span>
                            </Col>
                        </Row>
                        {team.users.map(staff => {
                            console.log(team.node, staff);
                            return <Row style={{ margin: '0 0 5px 0' }}>
                                {(staff.value.teamId > 0 && staff.value.teamId === team.node.value)
                                    ? <span>{staff.title}<sup style={{ color: 'red' }}>{'leader'}</sup></span>
                                    : <span>{staff.title}</span>}

                            </Row>;
                        })}
                        <Divider style={{ margin: 5 }} />
                    </>)
                }
            </Col>
        </Row>
    </>;
}

export { PermissionModal, ExtendPermissionModal };